const tenants = (tenants = [], action) => {
  switch (action.type) {
    case 'FETCH_TENANTS':
      return action.payload
    default:
      return tenants
  }
}
export default tenants
